import type { DarijaText } from './overlay';

type D = DarijaText;
export interface ServiceOverlay {
  title: D;
  metaTitle: D;
  metaDescription: D;
  intro: D;
  sections: Array<{ heading: D; body: D }>;
  faq?: Array<{ q: D; a: D }>;
}

// Darija of src/data/serviceContent.ts (/services/{slug}), part 1. Prices, brands and structure follow the French text.
export const SERVICE_DARIJA_PART1: Record<string, ServiceOverlay> = {
  plomberie: {
    title: { darija: 'Blombi f d-dar f lMaghrib', darija_ar: 'بلومبي فالدار فالمغرب' },
    metaTitle: {
      darija: 'Blombi mo2ahhal f lMaghrib – Devis bla fllous | Bricolat',
      darija_ar: 'بلومبي مؤهل فالمغرب – ديفي بلا فلوس | Bricolat',
    },
    metaDescription: {
      darija: 'Lqa blombi mohtarif f lMaghrib kamel. Dépannage mosta3jil, tarkib sanitaire, kachf t-tasarrob. Devis bla fllous, sna3iyya mt2akkdin.',
      darija_ar: 'لقا بلومبي محترف فالمغرب كامل. دبانّاج مستعجل، تركيب الصانيطير، كشف التسرب. ديفي بلا فلوس، صناعية متأكدين.',
    },
    intro: {
      darija: 'Kat-qelleb 3la blombi f lMaghrib? Bricolat kat-rbtek b blombiyya mo2ahhalin w mt2akkdin f ga3 l-mdon l-kbar: Casablanca, Rabat, Marrakech, Tanger, Agadir w bzaf khrin. Khod bzaf d-devisat bla fllous w khtar l-mhani li kay-lay9 l-budget w l-ajal dyalk.',
      darija_ar: 'كتقلب على بلومبي فالمغرب؟ Bricolat كتربطك مع بلومبية مؤهلين ومتأكدين فكاع المدن الكبار: الدار البيضاء، الرباط، مراكش، طنجة، أكادير وبزاف خرين. خد بزاف ديال الديفيات بلا فلوس واختار المهني لي كيلايق الميزانية والأجل ديالك.',
    },
    sections: [
      {
        heading: { darija: 'Khadamat s-sbaka li kat-ghatti', darija_ar: 'خدمات السباكة لي كنغطيو' },
        body: {
          darija: `L-blombiyya dyalna kay-tkallfou b ga3 anwa3 t-tadakhholat, sawa2 kant 7ala mosta3jila wla machrou3 mkhattat. Mn akthar l-khadamat matloubin:

Dépannage w tasarrob l-ma — Robinet kaytqattar, canalisation msdouda, WC kaysrreb wla chasse d-l-ma khaser. S-sna3iyya dyalna kay-tdkhlou f l-isti3jal f nfs n-nhar bach y9llou l-khasaya2 dyal l-ma.

Tarkib sanitaire — Pose wla tabdil dyal baignoire, lavabo, évier, receveur d-douche wla WC suspendu. L-blombiyya dyalna kay-3rfou l-ma3ayir w l-marqat li kaynin f lMaghrib (Star, Jacob Delafon, Grohe…).

Chauffe-eau w chaudière — Tarkib, tabdil wla siyana dyal chauffe-eau kahraba2i, b l-ghaz wla chamsi. Tn9iyat t-tartir w tmtal l-ma3ayir.

Kachf w islah t-tasarrob — B adawat kachf 7arari wla sawti, l-blombiyya kay-lqaw t-tasarrobat f l-7yout wla ta7t d-dalle bla hadm zayed.

Tsmim w tjdid salle de bain — Tsmim kamel dyal salle de bain: tuyauterie, robinetterie, rabt l-ajhiza s-sanitaire. Mzyan f ittar tjdid chamil.`,
          darija_ar: `البلومبية ديالنا كيتكلفو بكاع أنواع التدخلات، سواء كانت حالة مستعجلة ولا مشروع مخطط. من أكثر الخدمات مطلوبين:

دبانّاج وتسرب الما — روبيني كيقطر، كانالزاسيون مسدودة، WC كيسرب ولا شاس دو لو خاسر. الصناعية ديالنا كيتدخلو فالاستعجال فنفس النهار باش يقللو الخسائر ديال الما.

تركيب الصانيطير — بوز ولا تبديل ديال بينوار، لافابو، إيفيي، ريسيبور دوش ولا WC معلق. البلومبية ديالنا كيعرفو المعايير والماركات لي كاينين فالمغرب (Star، Jacob Delafon، Grohe…).

شوفو-أو وشودير — تركيب، تبديل ولا صيانة ديال شوفو-أو كهربائي، بالغاز ولا شمسي. تنقية الطرطير وتمتال المعايير.

كشف وإصلاح التسرب — بأدوات كشف حراري ولا صوتي، البلومبية كيلقاو التسربات فالحيوط ولا تحت الدال بلا هدم زايد.

تصميم وتجديد سال دو بان — تصميم كامل ديال سال دو بان: تويوتري، روبينيتيري، ربط الأجهزة الصانيطير. مزيان فإطار تجديد شامل.`,
        },
      },
      {
        heading: { darija: '3lach tkhtar blombi mohtarif?', darija_ar: 'علاش تختار بلومبي محترف؟' },
        body: {
          darija: `Tadakhhol dyal sbaka ma tssawb mzyan y9der ydir 3awaqib ghalya: khasaya2 l-ma, tasarrobat, l-3fn wla masakil f l-copropriété. Ila khdemti m3a sna3i mo2ahhal ghaydmen lik:

Salama : i7tiram ma3ayir t-tarkib (rabt l-ghaz, l-ard, daghT l-qnawat).
Damane : l-khdayem mghatta b l-mas2oliyya l-madaniyya l-mehniyya dyal s-sna3i.
Tawfir 3la l-mada l-b3id : tarkib mzyan kay-tjjeneb t-tasarrobat, t-tadakhholat l-mtkarrira w l-istihlak z-zayed dyal l-ma.
Sor3a : s-sna3iyya dyalna 3andhom l-adawat w l-qita3 l-lazima bach ytdakhlou b fa3aliyya.`,
          darija_ar: `تدخل ديال سباكة ما تصوبش مزيان يقدر يدير عواقب غالية: خسائر الما، تسربات، العفن ولا مشاكل فالكوبروبرييتي. إلا خدمتي مع صانعي مؤهل غيضمن ليك:

السلامة : احترام معايير التركيب (ربط الغاز، الأرض، ضغط القنوات).
الضمان : الخدايم مغطاة بالمسؤولية المدنية المهنية ديال الصانعي.
التوفير على المدى البعيد : تركيب مزيان كيتجنب التسربات، التدخلات المتكررة والاستهلاك الزايد ديال الما.
السرعة : الصناعية ديالنا عندهم الأدوات والقطع اللازمة باش يتدخلو بفعالية.`,
        },
      },
      {
        heading: { darija: 'Chhal kaykhllas blombi f lMaghrib?', darija_ar: 'شحال كيخلص بلومبي فالمغرب؟' },
        body: {
          darija: `Taman dyal blombi f lMaghrib kaykhtalef 7asb tabi3at w t3qid t-tadakhhol:

Fatt7 canalisation : bin 150 w 400 MAD 7asb t-technicité.
Islah tasarrob : bin 100 w 500 MAD (m3a l-qita3).
Tabdil robinetterie : bin 200 w 800 MAD (l-yd l-3amla).
Tarkib chauffe-eau : bin 400 w 1 200 MAD (bla l-jihaz).
Tsmim salle de bain kamla : mn 5 000 MAD l s-sbaka wa7dha.

Had l-fawariq ghir tawjihiyya. F Bricolat, kat-weslek devisat khassa w wadi7a qbel ay tadakhhol.`,
          darija_ar: `ثمن ديال بلومبي فالمغرب كيختلف على حسب طبيعة وتعقيد التدخل:

فتح كانالزاسيون : بين 150 و 400 MAD على حسب التيكنيسيتي.
إصلاح تسرب : بين 100 و 500 MAD (مع القطع).
تبديل روبينيتيري : بين 200 و 800 MAD (اليد العاملة).
تركيب شوفو-أو : بين 400 و 1 200 MAD (بلا الجهاز).
تصميم سال دو بان كاملة : من 5 000 MAD للسباكة وحدها.

هاد الفوارق غير توجيهية. فـ Bricolat، كتوصلك ديفيات خاصة وواضحة قبل أي تدخل.`,
        },
      },
      {
        heading: { darija: 'Kifach tlqa blombi f Bricolat?', darija_ar: 'كيفاش تلقى بلومبي فـ Bricolat؟' },
        body: {
          darija: `L-mosatara sahla w sari3a:

1. Chra7 l-7aja dyalk — Dkhkhel talabek f chi daqayeq: noo3 t-tadakhhol, l-mdina, l-awqat li bghiti.
2. Twssel b devisat — Blombiyya mo2ahhalin mn mante9tek kay-tsslou bik b taman-hom w tawaffor-hom.
3. Qaren w khtar — Chouf ara2 z-zbayen, chhadat w tsawer d-khdayem li dazt.
4. L-blombi kaytdakhhal — Mnin kat9bel d-devis, s-sna3i kayji l dartek f l-woqt li tfa9tou 3lih.`,
          darija_ar: `المسطرة سهلة وسريعة:

1. شرح الحاجة ديالك — دخل طلبك فشي دقايق: نوع التدخل، المدينة، الأوقات لي بغيتي.
2. توصل بديفيات — بلومبية مؤهلين من المنطقة ديالك كيتصلو بيك بالثمن ديالهم والتوفر ديالهم.
3. قارن واختار — شوف آراء الكليان، الشهادات وتصاور الخدايم لي داز.
4. البلومبي كيتدخل — منين كتقبل الديفي، الصانعي كيجي لدارك فالوقت لي تفقتو عليه.`,
        },
      },
    ],
    faq: [
      {
        q: { darija: 'Wach kayn blombi mojoud f l-weekend?', darija_ar: 'واش كاين بلومبي موجود فالويكاند؟' },
        a: { darija: 'Iyeh. Bzaf d-s-sna3iyya l-mssjjlin f Bricolat kay-qtar7ou tadakhholat s-sbt w, l-l-mosta3jilat, l-a7ad.', darija_ar: 'إيه. بزاف ديال الصناعية المسجلين فـ Bricolat كيقترحو تدخلات السبت و، للمستعجلات، الأحد.' },
      },
      {
        q: { darija: 'Kifach kayt3mal l-khlas?', darija_ar: 'كيفاش كيتعمل الخلاص؟' },
        a: { darija: 'Bricolat hiya plateforme l-rabt. Kat9bel d-devis dyal s-sna3i qbel ma ybda l-khedma, w l-khlas kaytsawwa mbacharatan binatk w binat s-sna3i, mn ba3d l-injaz. Bricolat ma katsayyer l-mo3amalat l-maliyya.', darija_ar: 'Bricolat هي بلاطفورم الربط. كتقبل الديفي ديال الصانعي قبل ما تبدا الخدمة، والخلاص كيتصوى مباشرة بينك وبين الصانعي، من بعد الإنجاز. Bricolat ما كتسيرش المعاملات المالية.' },
      },
      {
        q: { darija: 'Kifach ntjjenb n-nssaba?', darija_ar: 'كيفاش نتجنب النصابة؟' },
        a: { darija: 'Ga3 l-mqaddimin f Bricolat mt2akkdin: l-hawiyya m2akkda, ara2 z-zbayen 7a9i9iyya w profil mehni zaher. T9der tchouf l-ta2rikh dyal t-tadakhholat w chhadathom qbel ma ta3tihom l-khedma.', darija_ar: 'كاع المقدمين فـ Bricolat متأكدين: الهوية مأكدة، آراء الكليان حقيقية وبروفايل مهني ظاهر. تقدر تشوف التاريخ ديال التدخلات والشهادات ديالهم قبل ما تعطيهم الخدمة.' },
      },
    ],
  },
  electricite: {
    title: { darija: 'Electricien f d-dar f lMaghrib', darija_ar: 'كهربائي فالدار فالمغرب' },
    metaTitle: {
      darija: 'Electricien mo2ahhal f lMaghrib – Devis bla fllous | Bricolat',
      darija_ar: 'كهربائي مؤهل فالمغرب – ديفي بلا فلوس | Bricolat',
    },
    metaDescription: {
      darija: 'Lqa electricien mohtarif w m3tamad f lMaghrib. Tarkib, dépannage panne kahrabaiyya, tablo electrique, mise aux normes. Devis bla fllous.',
      darija_ar: 'لقا كهربائي محترف ومعتمد فالمغرب. تركيب، دبانّاج بان كهربائية، تابلو إلكتريك، ميز أو نورم. ديفي بلا فلوس.',
    },
    intro: {
      darija: 'Lqa electricien mo2ahhal w m3tamad f ga3 lMaghrib m3a Bricolat. Sawa2 kant panna mosta3jila, tarkib jdid wla mise aux normes dyal r-ré7seau l-kahrabai, s-sna3iyya dyalna kay-tdkhlou f aqrab l-ajal f Casablanca, Rabat, Marrakech w f l-mante9a kamla.',
      darija_ar: 'لقا كهربائي مؤهل ومعتمد فكاع المغرب مع Bricolat. سواء كانت بان مستعجلة، تركيب جديد ولا ميز أو نورم ديال الريزو الكهربائي، الصناعية ديالنا كيتدخلو فأقرب الآجال فالدار البيضاء، الرباط، مراكش وفالمنطقة كاملة.',
    },
    sections: [
      {
        heading: { darija: 'Khadamat kahrabaiyya mojouda', darija_ar: 'خدمات كهربائية موجودة' },
        body: {
          darija: `Dépannage kahrabai mosta3jil — Panna d-d-dow, disjoncteur kayn9ez, prise ma b9atch kat-khdem wla court-circuit. L-electriciens dyalna kay-tdkhlou f l-isti3jal bach yrdd l-installation b salama.

Tarkib w câblage — Pose dyal prises, interrupteurs, l-i7ara (LED, spots encastrés, appliques), gaines w tableaux electriques l l-binayat l-jdida wla t-tjdid.

Mise aux normes — Tmtal l-installation dyalk 7asb l-ma3ayir l-jariya f lMaghrib (ONEE). Tabdil tablo electrique 9dim, zyada dyal différentiel, mise à la terre.

I7ara dakhiliyya w kharijiyya — Pose dyal luminaires, i7arat l-jnan, spots dyal l-aman, bandeau LED, domotique d-l-i7ara.

Borne d charge l-sayyara kahrabaiyya — Tarkib wallbox f d-dar bach tcharji sayyartek l-kahrabaiyya wla hybride.`,
          darija_ar: `دبانّاج كهربائي مستعجل — بان د الضو، ديجونكتور كيقفز، بريز ما بقاتش كتخدم ولا كور سيركي. الكهربائيين ديالنا كيتدخلو فالاستعجال باش يردو الانستالاسيون بسلامة.

تركيب وكابلاج — بوز ديال بريز، أنتيرابتورات، الإضاءة (LED، سبوتات مدمجة، أبلیك)، كاين وتابلوات كهربائية للبنايات الجديدة ولا التجديد.

ميز أو نورم — تمتال الانستالاسيون ديالك على حسب المعايير الجارية فالمغرب (ONEE). تبديل تابلو كهربائي قديم، زيادة ديال ديفيرونسيال، ميز أ لا تير.

إضاءة داخلية وخارجية — بوز ديال لوميناير، إضاءات الجنان، سبوتات ديال الأمان، باندو LED، دوموتيك الإضاءة.

بورن شارج السيارة الكهربائية — تركيب وولبوكس فالدار باش تشارجي السيارة الكهربائية ولا هيبريد ديالك.`,
        },
      },
      {
        heading: { darija: 'S-salama l-kahrabaiyya: 3lach ma tdirhach b yddek?', darija_ar: 'السلامة الكهربائية: علاش ما تديرهاش بيدك؟' },
        body: {
          darija: `Installation kahrabaiyya ghir mtabqa hiya mn awwal asbab l-7ra2i9 f d-dour. F lMaghrib, ghir l-electriciens l-mo2ahhalin li y9edrou ytdakhhlou 3la chabakat l-jahd l-mon5afid bach yddmnou l-mutabaqa w s-salama. L-mhani l-m3tamad kaydmen lik khedma mtabqa l ma3ayir ONEE, himaya mn khatar s-sa9a w l-7rii9, damane 3la l-khdayem li tsawbat, w ta2min s-salih f 7alat l-7adit.`,
          darija_ar: `انستالاسيون كهربائية غير مطابقة هي من أول أسباب الحرائق فالدور. فالمغرب، غير الكهربائيين المؤهلين لي يقدرو يتدخلو على شبكات الجهد المنخفض باش يضمنو المطابقة والسلامة. المهني المعتمد كيضمن ليك خدمة مطابقة لمعايير ONEE، حماية من خطر الصعقة والحريق، ضمان على الخدايم لي تصوبات، وتأمين صالح فحالة الحادث.`,
        },
      },
      {
        heading: { darija: 'Tamanat electricien f lMaghrib', darija_ar: 'أثمنة الكهربائي فالمغرب' },
        body: {
          darija: `L-tamanat kat-khtalef 7asb t3qid t-tadakhhol w l-mdina:

Tabdil prise wla interrupteur : 80 l 200 MAD.
Dépannage panne kahrabaiyya : 150 l 500 MAD.
Tabdil tablo electrique : 800 l 2 500 MAD.
Installation kamla d-chqa (60 m²) : 4 000 l 10 000 MAD.
Pose borne de charge : 1 500 l 3 500 MAD (bla l-jihaz).

Twssel b devisat da9i9a w khassa melli tn7i talabek f Bricolat.`,
          darija_ar: `الأثمنة كتختلف على حسب تعقيد التدخل والمدينة:

تبديل بريز ولا أنتيرابتور : 80 إلى 200 MAD.
دبانّاج بان كهربائية : 150 إلى 500 MAD.
تبديل تابلو كهربائي : 800 إلى 2 500 MAD.
انستالاسيون كاملة ديال شقة (60 m²) : 4 000 إلى 10 000 MAD.
بوز بورن شارج : 1 500 إلى 3 500 MAD (بلا الجهاز).

توصل بديفيات دقيقة وخاصة ملي تنشر طلبك فـ Bricolat.`,
        },
      },
    ],
    faq: [
      {
        q: { darija: 'Disjoncteur raisi dyali kayn9ez b tikrar, chnou ndir?', darija_ar: 'الديجونكتور الرئيسي ديالي كيقفز بتكرار، شنو ندير؟' },
        a: { darija: 'Hadchi y9der ykoun sabab d-surcharge f chabaka, court-circuit wla jihaz khasser. Electricien khassou ychakhkhes l-installation bach y3raf s-sabab w yjjenneb ay khatar dyal 7ariqa.', darija_ar: 'هادشي يقدر يكون سبب ديال سورشارج فالشبكة، كور سيركي ولا جهاز خاسر. الكهربائي خاصو يشخص الانستالاسيون باش يعرف السبب ويتجنب أي خطر ديال حريقة.' },
      },
      {
        q: { darija: 'Kifach nt2akked belli electricien m3tamad?', darija_ar: 'كيفاش نتأكد بلي كهربائي معتمد؟' },
        a: { darija: 'F Bricolat, koul mqaddim 3ndou profil m2akkad m3a chhadat-hom, ara2 z-zbayen w ta2rikh l-khdayem. T9der 7ta tlob mnnhom direct chhadat l-mutabaqa dyal ONEE.', darija_ar: 'فـ Bricolat، كل مقدم عندو بروفايل مأكد مع الشهادات ديالهم، آراء الكليان وتاريخ الخدايم. تقدر حتى تطلب منهم مباشرة شهادة المطابقة ديال ONEE.' },
      },
    ],
  },
  peinture: {
    title: { darija: 'Sbbagh d-l-binaya f lMaghrib', darija_ar: 'صباغ البناية فالمغرب' },
    metaTitle: {
      darija: 'Sbbagh mohtarif f lMaghrib – Devis bla fllous | Bricolat',
      darija_ar: 'صباغ محترف فالمغرب – ديفي بلا فلوس | Bricolat',
    },
    metaDescription: {
      darija: 'Lqa sbbagh mo2ahhal f lMaghrib bach tjeddid dakhl wla kharij dar-k. S-sbagha d-l-7yout, ravalement d-l-facade, dékoration. Devis bla fllous.',
      darija_ar: 'لقا صباغ مؤهل فالمغرب باش تجدد داخل ولا خارج دارك. الصباغة ديال الحيوط، رافالمون الفاصاد، ديكوراسيون. ديفي بلا فلوس.',
    },
    intro: {
      darija: 'Jeddid l-dakhel wla l-kharij dyal dar-k m3a s-sbbaghin l-mohtarifin dyalna f lMaghrib. Bricolat katrbtek b sna3iyya mo2ahhalin mkhtassin f s-sbagha d-l-7yout, d-dékoration d-dakhiliyya, ravalement d-l-facade w l-ghita2at d-l-7yout f ga3 l-mdon l-kbar l-maghribiyya.',
      darija_ar: 'جدد الداخل ولا الخارج ديال دارك مع الصباغين المحترفين ديالنا فالمغرب. Bricolat كتربطك مع صناعية مؤهلين مختصين فالصباغة ديال الحيوط، الديكوراسيون الداخلية، رافالمون الفاصاد والغطاء ديال الحيوط فكاع المدن الكبار المغربية.',
    },
    sections: [
      {
        heading: { darija: 'Anwa3 khdayem s-sbagha', darija_ar: 'أنواع خدايم الصباغة' },
        body: {
          darija: `Sbagha dakhiliyya — L-bitat, s-salonat, l-kwazin, salles de bain w l-mkatib. S-sbbaghin dyalna kay-3rfou ga3 t-tqniyyat: sbagha mate, satinée, brillante, lessivable w sbagha dedd r-ratouba mnasba l l-manakh l-maghribi.

Sbagha kharijiyya w facade — Ravalement d-l-facade, sbagha d-terrasse, mo3alaja dedd r-ratouba l l-7yout l-kharijiyya. 7imaya mn l-aqtar, ch-chams l-qawiyya w l-hwa l-malih f l-manati9 s-sa7iliyya.

Dékoration w effets khassa — Stuc, béton ciré, enduit décoratif, sbaghat handasiyya trend. Mzyan l r-riyad, ch-chqeq l-3asriyya wla l-mahallat t-tijariyya.

Tjdid mn ba3d l-7ad ita — I3adat t-tahyi2a mn ba3d khasaya2 l-ma, l-3fn wla b9a3 mostamirra. Mo3alaja f l-3omq w tatbiq sbagha mnasba.`,
          darija_ar: `صباغة داخلية — البيوت، الصالونات، الكوازين، سال دو بان والمكاتب. الصباغين ديالنا كيعرفو كاع التقنيات: صباغة مات، ساتينيه، بريّونت، ليساڤابل وصباغة ضد الرطوبة مناسبة للمناخ المغربي.

صباغة خارجية وفاصاد — رافالمون الفاصاد، صباغة التراس، معالجة ضد الرطوبة للحيوط الخارجية. حماية من الأقطار، الشمس القوية والهوا المالح فالمناطق الساحلية.

ديكوراسيون وإيفي خاصة — ستيك، بيطون سيريه، أندوي ديكوراتيف، صباغات هندسية ترند. مزيان للرياضات، الشقق العصرية ولا المحلات التجارية.

تجديد من بعد الحادث — إعادة التهيئة من بعد خسائر الما، العفن ولا بقع مستمرة. معالجة فالعمق وتطبيق صباغة مناسبة.`,
        },
      },
      {
        heading: { darija: 'Tamanat s-sbagha f lMaghrib', darija_ar: 'أثمنة الصباغة فالمغرب' },
        body: {
          darija: `Taman s-sbagha kaytb3 l-masa7a, t-t7dir d-daruri w noo3 l-finition l-matloub:

Sbagha dakhiliyya bsita : 20 l 45 MAD / m².
Sbagha m3a t-t7dir (enduit, ponçage) : 40 l 80 MAD / m².
Enduit décoratif wla stuc : 80 l 200 MAD / m².
Ravalement d-l-facade : 60 l 120 MAD / m².

Had t-tamanat fihom l-yd l-3amla. S-sbagha w l-lawazim ghaliban kaytkhllsou zyada wla dakhlin 7asb s-sna3iyya. Qaren d-devisat bla fllous f Bricolat.`,
          darija_ar: `ثمن الصباغة كيتبع المساحة، التحضير الضروري ونوع الفينيسيون المطلوب:

صباغة داخلية بسيطة : 20 إلى 45 MAD / m².
صباغة مع التحضير (أندوي، بونساج) : 40 إلى 80 MAD / m².
أندوي ديكوراتيف ولا ستيك : 80 إلى 200 MAD / m².
رافالمون الفاصاد : 60 إلى 120 MAD / m².

هاد الأثمنة فيهم اليد العاملة. الصباغة واللوازم غالبا كيتخلصو زيادة ولا داخلين على حسب الصناعية. قارن الديفيات بلا فلوس فـ Bricolat.`,
        },
      },
      {
        heading: { darija: 'Nasa2i7 bach tkhtar s-sbagha mzyan f lMaghrib', darija_ar: 'نصائح باش تختار الصباغة مزيان فالمغرب' },
        body: {
          darija: `Ikhtiyar s-sbagha kaytb3 l-isti3mal w l-manakh l-mahalli. F l-mdon s-sa7iliyya (Casablanca, Agadir, Tanger), fddel sbaghat dedd r-ratouba w mqawima l l-milh. F l-mdon d-dakhiliyya (Marrakech, Fès), t-taghayyorat d-d-darajat l-7arara kat-7taj sbaghat mrina l l-facades.

L-dakhel, s-sbaghat l-lessivables daruriyyin f l-kwazin w salles de bain, w s-sbaghat l-mate mzyanin l s-s9of w l-bitat. S-sbbagh dyalk f Bricolat y9der y3awnek f ikhtiyar a7san l-montajat l-sya9 dyalk.`,
          darija_ar: `اختيار الصباغة كيتبع الاستعمال والمناخ المحلي. فالمدن الساحلية (الدار البيضاء، أكادير، طنجة)، فضل صباغات ضد الرطوبة ومقاومة للملح. فالمدن الداخلية (مراكش، فاس)، التغيرات ديال درجات الحرارة كتحتاج صباغات مرنة للفاصادات.

الداخل، الصباغات الليساڤابل ضرورية فالكوازين وسال دو بان، والصباغات المات مزيانين للسقوف والبيوت. الصباغ ديالك فـ Bricolat يقدر يعاونك فاختيار أحسن المنتوجات للسياق ديالك.`,
        },
      },
    ],
    faq: [
      {
        q: { darija: 'Wach khass nkhrej mn d-dar f wqt s-sbagha?', darija_ar: 'واش خاص نخرج من الدار فوقت الصباغة؟' },
        a: { darija: 'L-bit wa7da, 3adatan ma khass-ch tkhrej. L-chqa kamla, mn n-nasi7 tchwwi l-bitat b9dr l-imkan. S-sbaghat l-7adita kat-nchef f 2 l 4 sa3at.', darija_ar: 'للبيت وحدة، عادة ما خاصش تخرج. للشقة كاملة، من النصيح تهوي البيوت بقدر الإمكان. الصباغات الحديثة كتنشف فـ 2 إلى 4 ساعات.' },
      },
      {
        q: { darija: 'Chhal kat-akhod mn l-woqt sbagha dyal chqa dyal 80 m²?', darija_ar: 'شحال كتاخد من الوقت صباغة ديال شقة ديال 80 m²؟' },
        a: { darija: 'Sbbagh wa7ed 3adatan kayakhod 3 l 5 yyam l chqa dyal 80 m² m3a juj tbaqat. Fari9 dyal juj sbbaghin y9der ykammel f 2 l 3 yyam.', darija_ar: 'صباغ واحد عادة كياخد 3 إلى 5 أيام لشقة ديال 80 m² مع جوج طبقات. فريق ديال جوج صباغين يقدر يكمل فـ 2 إلى 3 أيام.' },
      },
    ],
  },
  nettoyage: {
    title: { darija: 'N-nadafa f d-dar f lMaghrib', darija_ar: 'النظافة فالدار فالمغرب' },
    metaTitle: {
      darija: 'Khidma dyal n-nadafa mohtarifa f lMaghrib – Devis bla fllous | Bricolat',
      darija_ar: 'خدمة النظافة المحترفة فالمغرب – ديفي بلا فلوس | Bricolat',
    },
    metaDescription: {
      darija: 'Lqa femme de ménage wla fari9 nadafa mohtarif f lMaghrib. Ménage, nadafat nihayat chantier, zjaj, moquettes. Devis bla fllous.',
      darija_ar: 'لقا فام دو مناج ولا فريق نظافة محترف فالمغرب. مناج، نظافة نهاية شونتيي، زجاج، موكيط. ديفي بلا فلوس.',
    },
    intro: {
      darija: 'Bricolat katrbtek b mohtarifin d-n-nadafa f ga3 lMaghrib. Afrad wla charikat, lqa l-khidma li kat-lay9 l 7ajatk: ménage mntadam, nadafa mn ba3d l-khdayem, nadafat l-tarhil wla siyanat l-mahallat t-tijariyya.',
      darija_ar: 'Bricolat كتربطك مع محترفين ديال النظافة فكاع المغرب. أفراد ولا شركات، لقا الخدمة لي كتلايق لحاجتك: مناج منتظم، نظافة من بعد الخدايم، نظافة الترحيل ولا صيانة المحلات التجارية.',
    },
    sections: [
      {
        heading: { darija: 'Khadamat n-nadafa l-mojouda', darija_ar: 'خدمات النظافة الموجودة' },
        body: {
          darija: `Ménage mntadam f d-dar — Siyana osbou3iyya wla mrtayn f ch-chhar l chqtek wla villa dyalek: t-tghbir, l-ard, l-kwzina, salle de bain, z-zjaj d-dakhiliyya.

Nadafat nihayat chantier — Mn ba3d khdayem t-tjdid, fari9 mkhtass kayn7i t-torab, b9ayat l-gypse, b9a3 s-sbagha w b9ayat l-mawad. Natija jahza.

Nadafat t-tarhil — Nadafa kamla qbel d-dkhoul wla l-khrouj mn l-blasa. Etat des lieux nqi daman.

Nadafat z-zjaj w l-stores — Ghsil l-bay vitrées, nwafed l-3aliya, vérandas w stores kharijiyya.

Nadafat l-moquettes w l-canapés — Mo3alaja b l-bokhar wla extraction bach ytn7a l-b9a3, l-mosabbibat l-ta7assos w r-rawa2i7.

Nadafat l-mahallat l-mehniyya — Mkatib, tijara, mata3im, fnadeq. Tadakhhol khareej awqat l-fat7.`,
          darija_ar: `مناج منتظم فالدار — صيانة أسبوعية ولا مرتين فالشهر لشقتك ولا فيلا ديالك: التغبير، الأرض، الكوزينة، سال دو بان، الزجاج الداخلية.

نظافة نهاية شونتيي — من بعد خدايم التجديد، فريق مختص كينحي التراب، بقايا الجبص، بقع الصباغة وبقايا المواد. نتيجة جاهزة.

نظافة الترحيل — نظافة كاملة قبل الدخول ولا الخروج من البلاصة. إيتا دي ليو نقي ضمان.

نظافة الزجاج والستورات — غسيل الباي ڤيتري، النوافذ العالية، ڤيرانداس وستورات خارجية.

نظافة الموكيط والكانابي — معالجة بالبخار ولا إكستراكسيون باش تنحى البقع، مسببات التحسس والروايح.

نظافة المحلات المهنية — مكاتب، تجارة، مطاعم، فنادق. تدخل خارج أوقات الفتح.`,
        },
      },
      {
        heading: { darija: 'Tamanat n-nadafa f lMaghrib', darija_ar: 'أثمنة النظافة فالمغرب' },
        body: {
          darija: `Ménage mntadam (3h) : 150 l 300 MAD / jalsa.
Nadafa kamla l chqa 60 m² : 400 l 800 MAD.
Nadafat nihayat chantier (60 m²) : 600 l 1 500 MAD.
Nadafat moquette l koul m² : 15 l 40 MAD / m².
Ghsil z-zjaj (chqa) : 200 l 600 MAD.

Ga3 l-khadamat kat9bel t-takhsis. Tlob devis dyalk bla fllous f Bricolat.`,
          darija_ar: `مناج منتظم (3h) : 150 إلى 300 MAD / جلسة.
نظافة كاملة لشقة 60 m² : 400 إلى 800 MAD.
نظافة نهاية شونتيي (60 m²) : 600 إلى 1 500 MAD.
نظافة موكيط لكل m² : 15 إلى 40 MAD / m².
غسيل الزجاج (شقة) : 200 إلى 600 MAD.

كاع الخدمات كتقبل التخصيص. طلب الديفي ديالك بلا فلوس فـ Bricolat.`,
        },
      },
    ],
    faq: [
      {
        q: { darija: 'Wach l-mon5ajat dyal n-nadafa mojouda?', darija_ar: 'واش المنتوجات ديال النظافة موجودة؟' },
        a: { darija: 'Aghlab l-mqaddimin kay-jibou l-mon5ajat l-mehniyya dyalhom. Walakin t9der tchra7 l-ikhtiyarat dyalk (mon5ajat ikologiyya, bla riha…) melli kat-dir t-talab.', darija_ar: 'أغلب المقدمين كيجيبو المنتوجات المهنية ديالهم. ولكن تقدر تشرح الاختيارات ديالك (منتوجات إيكولوجية، بلا ريحة…) ملي كتدير الطلب.' },
      },
      {
        q: { darija: 'Wach l-modakhkhilin mt2akkdin?', darija_ar: 'واش المتدخلين متأكدين؟' },
        a: { darija: 'Iyeh. F Bricolat, koul mqaddim hawiyyto m2akkda w ara2 z-zbayen m3tamda. T9der tchouf ta2rikh-hom qbel ma tkhtarhom.', darija_ar: 'إيه. فـ Bricolat، كل مقدم الهوية ديالو مأكدة وآراء الكليان معتمدة. تقدر تشوف التاريخ ديالهم قبل ما تختارهم.' },
      },
    ],
  },
  menage: {
    title: { darija: 'Ménage f d-dar f lMaghrib', darija_ar: 'المناج فالدار فالمغرب' },
    metaTitle: {
      darija: 'Femme de ménage f lMaghrib – Devis bla fllous | Bricolat',
      darija_ar: 'فام دو مناج فالمغرب – ديفي بلا فلوس | Bricolat',
    },
    metaDescription: {
      darija: 'Lqa femme de ménage wla khidma dyal ménage f d-dar f lMaghrib. Siyana mntadma, ménage osbou3i, sna3iyya mt2akkdin. Devis bla fllous.',
      darija_ar: 'لقا فام دو مناج ولا خدمة ديال مناج فالدار فالمغرب. صيانة منتظمة، مناج أسبوعي، صناعية متأكدين. ديفي بلا فلوس.',
    },
    intro: {
      darija: 'Bricolat katrbtek b mohtarifin d-l-ménage f d-dar f ga3 lMaghrib. Sawa2 kat-qelleb 3la mosa3ida mnziliyya mntadma, ménage mra wa7da wla mosa3ada l l-kbar f s-senn, lqa l-mqaddim li kay-lay9 l-wad3iyytek.',
      darija_ar: 'Bricolat كتربطك مع محترفين ديال المناج فالدار فكاع المغرب. سواء كتقلب على مساعدة منزلية منتظمة، مناج مرة وحدة ولا مساعدة للكبار فالسن، لقا المقدم لي كيلايق الوضعية ديالك.',
    },
    sections: [
      {
        heading: { darija: 'Khadamat l-ménage f d-dar l-mojouda', darija_ar: 'خدمات المناج فالدار الموجودة' },
        body: {
          darija: `Ménage mntadam — Siyana osbou3iyya wla mrtayn f ch-chhar l d-dar: t-tghbir, l-ard, l-kwzina, salle de bain, t-tartib. Femme de ménage kat-tkhdem 7asb planning m7added mn qbel.

Ménage mra wa7da — Nadafa 3amiqa l chqtek wla villa dyalek l-moujaba, d-dokhoul l-madrasi wla mn ba3d ghyab twil. Natija mn ghir 3ayb f tadakhhol wa7ed.

Mosa3ada f d-dar — Mourafaqat l-kbar f s-senn wla li 7arakathom sa3ba f l-mohimmat l-yawmiyya: siyanat l-mskn, ghsil, kay, tswwa9.

Repassage — Khidma d-repassage f d-dar wla t-takhd w t-tawsil d-t-tyab. T-taman b l-kilo wla b s-sa3a 7asb l-mqaddim.

Nadafat t-tarhil — I3adat t-tahyi2a kamla l l-mskn qbel d-dokhoul wla l-khrouj: l-kwzina, s-sanitaire, z-zjaj, l-ard.`,
          darija_ar: `مناج منتظم — صيانة أسبوعية ولا مرتين فالشهر للدار: التغبير، الأرض، الكوزينة، سال دو بان، الترتيب. فام دو مناج كتخدم على حسب بلانينغ محدد من قبل.

مناج مرة وحدة — نظافة عميقة لشقتك ولا فيلا ديالك لمناسبة، الدخول المدرسي ولا من بعد غياب طويل. نتيجة من غير عيب فتدخل واحد.

مساعدة فالدار — مرافقة الكبار فالسن ولا لي حركتهم صعبة فالمهمات اليومية: صيانة المسكن، الغسيل، الكي، التسوق.

ريباساج — خدمة الريباساج فالدار ولا الأخذ والتوصيل ديال الطيّاب. الثمن بالكيلو ولا بالساعة على حسب المقدم.

نظافة الترحيل — إعادة التهيئة كاملة للمسكن قبل الدخول ولا الخروج: الكوزينة، الصانيطير، الزجاج، الأرض.`,
        },
      },
      {
        heading: { darija: 'Tamanat l-ménage f d-dar f lMaghrib', darija_ar: 'أثمنة المناج فالدار فالمغرب' },
        body: {
          darija: `Ménage mntadam (3h) : 150 l 300 MAD l koul jalsa.
Ménage mra wa7da (chqa 60 m²) : 400 l 800 MAD.
Mosa3ada f d-dar (nos nhar) : 200 l 450 MAD.
Repassage (l koul kg) : 20 l 40 MAD / kg.

T-tamanat kat-khtalef 7asb l-mdina, l-masa7a w tikrar t-tadakhholat. Tlob devis dyalk bla fllous f Bricolat.`,
          darija_ar: `مناج منتظم (3h) : 150 إلى 300 MAD لكل جلسة.
مناج مرة وحدة (شقة 60 m²) : 400 إلى 800 MAD.
مساعدة فالدار (نص نهار) : 200 إلى 450 MAD.
ريباساج (لكل kg) : 20 إلى 40 MAD / kg.

الأثمنة كتختلف على حسب المدينة، المساحة وتكرار التدخلات. طلب الديفي ديالك بلا فلوس فـ Bricolat.`,
        },
      },
    ],
    faq: [
      {
        q: { darija: 'Wach mon5ajat l-ménage mojouda?', darija_ar: 'واش منتوجات المناج موجودة؟' },
        a: { darija: 'Aghlab l-mqaddimin kay-jibou l-mon5ajat dyalhom. T9der tchra7 l-ikhtiyarat dyalk (mon5ajat ikologiyya, bla riha…) melli kat-dir t-talab.', darija_ar: 'أغلب المقدمين كيجيبو المنتوجات ديالهم. تقدر تشرح الاختيارات ديالك (منتوجات إيكولوجية، بلا ريحة…) ملي كتدير الطلب.' },
      },
      {
        q: { darija: 'Kifach nkhtar femme de ménage tthiq fiha?', darija_ar: 'كيفاش نختار فام دو مناج نثق فيها؟' },
        a: { darija: 'F Bricolat, koul mqaddim hawiyyto m2akkda w ara2 z-zbayen m3tamda. T9der tchouf ta2rikh t-tadakhholat dyalhom qbel ma tssal bihom.', darija_ar: 'فـ Bricolat، كل مقدم الهوية ديالو مأكدة وآراء الكليان معتمدة. تقدر تشوف التاريخ ديال التدخلات ديالهم قبل ما تتصل بيهم.' },
      },
      {
        q: { darija: 'Wach n9der n7jez ménage mntadam?', darija_ar: 'واش نقدر نحجز مناج منتظم؟' },
        a: { darija: 'Iyeh. Mn ba3d awwal talab, t9der tttafa9 direct m3a l-mqaddim 3la planning mntadam 7asb l-awqat dyalk.', darija_ar: 'إيه. من بعد أول طلب، تقدر تتفاق مباشرة مع المقدم على بلانينغ منتظم على حسب الأوقات ديالك.' },
      },
    ],
  },
  jardinage: {
    title: { darija: 'Jnanni f d-dar f lMaghrib', darija_ar: 'جناني فالدار فالمغرب' },
    metaTitle: {
      darija: 'Jnanni mohtarif f lMaghrib – Devis bla fllous | Bricolat',
      darija_ar: 'جناني محترف فالمغرب – ديفي بلا فلوس | Bricolat',
    },
    metaDescription: {
      darija: 'Lqa jnanni mo2ahhal f lMaghrib bach y-3ti l-jnan dyalk, taqlim s-siyaj, gazon, tsmim jnan. Devis bla fllous, sna3iyya mt2akkdin.',
      darija_ar: 'لقا جناني مؤهل فالمغرب باش يعتني بالجنان ديالك، تقليم السياج، ڭازون، تصميم جنان. ديفي بلا فلوس، صناعية متأكدين.',
    },
    intro: {
      darija: 'Bricolat katrbtek b jnananiyya mohtarifin f ga3 l-mdon l-kbar f lMaghrib. Siyanat l-jnan, taqlim, sqi automatique wla tsmim jnan: s-sna3iyya dyalna kay-t3tnaw b l-masa7a l-khdra dyalek.',
      darija_ar: 'Bricolat كتربطك مع جنانية محترفين فكاع المدن الكبار فالمغرب. صيانة الجنان، تقليم، سقي أوتوماتيك ولا تصميم جنان: الصناعية ديالنا كيعتانو بالمساحة الخضرا ديالك.',
    },
    sections: [
      {
        heading: { darija: 'Khadamat l-jnana l-mojouda', darija_ar: 'خدمات الجنانة الموجودة' },
        body: {
          darija: `Siyana mntadma l l-jnan — Tonte d-l-gazon, taqlim s-siyajat w ch-chjirat, tn9iyat l-3chb, nfkh l-awraq, jem3 w ikhraj l-fadlat l-khdra.

Tsmim w tahyi2at l-jnan — Tsmim d-l-jnan, ghars l-achjar w l-wrod, tsmim l-massifs, pose d-l-gazon tabi3i wla sina3i mnasb l l-manakh l-maghribi.

Sqi automatique — Tarkib w barmaja dyal anzimat s-sqi b t-ta9tir wla b r-rach. Tawfir l-ma m2akkad.

Taqlim l-achjar — Taqlim t-takwin, taqlim l-achjar l-kbar, qte3 mrakkaz. L-jnananiyya dyalna kay-tdkhlou b salama b l-ma3idat l-mnasba.`,
          darija_ar: `صيانة منتظمة للجنان — تونط ديال الڭازون، تقليم السياجات والشجيرات، تنقية العشب، نفخ الأوراق، جمع وإخراج الفضلات الخضرا.

تصميم وتهيئة الجنان — تصميم الجنان، غرس الأشجار والورود، تصميم المصيفات، بوز الڭازون طبيعي ولا صناعي مناسب للمناخ المغربي.

سقي أوتوماتيك — تركيب وبرمجة ديال أنظمة السقي بالتقطير ولا بالرش. توفير الما مأكد.

تقليم الأشجار — تقليم التكوين، تقليم الأشجار الكبار، قطع مراقب. الجنانية ديالنا كيتدخلو بسلامة بالمعدات المناسبة.`,
        },
      },
      {
        heading: { darija: 'L-jnana f lMaghrib: t-takayyof m3a l-manakh', darija_ar: 'الجنانة فالمغرب: التكيف مع المناخ' },
        body: {
          darija: `L-Maghrib 3ndou tanawwo3 manakhi kbir. F Agadir w 3la s-sa7il l-atlasi, l-jnana kat-stafed mn manakh khfif toul l-3am. F Marrakech w Fès, s-sif s-skhoun w ch-chaf kay-7tajou sqi sarim w ikhtiyar anwa3 mqawima.

L-jnananiyya dyalna kay-3rfou l-anwa3 l-mahalliyya w l-mtawassitiyya li kay-lay9ou l koul mante9a: ward 7mar, bougainvillées, nakhl, zitoun, l-ghars dyal l-limoun w l-a3chab l-3titiyya. Kay-nsa7ouk f l-awqat l-mnasba l-t-taqlim w s-siyana.`,
          darija_ar: `المغرب عندو تنوع مناخي كبير. فأكادير وعلى الساحل الأطلسي، الجنانة كتستافد من مناخ خفيف طول العام. فمراكش وفاس، الصيف السخون والشاف كيحتاجو سقي صارم واختيار أنواع مقاومة.

الجنانية ديالنا كيعرفو الأنواع المحلية والمتوسطية لي كيلايقو لكل منطقة: الورد الحمر، البوغانفيليا، النخيل، الزيتون، الليمون والأعشاب العطرية. كينصحوك فالأوقات المناسبة للتقليم والصيانة.`,
        },
      },
      {
        heading: { darija: 'Tamanat l-jnana f lMaghrib', darija_ar: 'أثمنة الجنانة فالمغرب' },
        body: {
          darija: `Siyanat l-jnan (nos nhar) : 200 l 500 MAD.
Tonte d-l-gazon (l koul m²) : 1 l 3 MAD / m².
Taqlim s-siyaj (l koul metr tooli) : 20 l 60 MAD.
Taqlim ch-chajra : 300 l 1 500 MAD 7asb l-7ajm.
Tarkib sqi automatique : mn 2 000 MAD.`,
          darija_ar: `صيانة الجنان (نص نهار) : 200 إلى 500 MAD.
تونط الڭازون (لكل m²) : 1 إلى 3 MAD / m².
تقليم السياج (لكل متر طولي) : 20 إلى 60 MAD.
تقليم الشجرة : 300 إلى 1 500 MAD على حسب الحجم.
تركيب سقي أوتوماتيك : من 2 000 MAD.`,
        },
      },
    ],
    faq: [
      {
        q: { darija: 'Chhal mn mra khass ysswab l-jnan?', darija_ar: 'شحال من مرة خاص يتصوب الجنان؟' },
        a: { darija: 'Ghaliban, ziyara wa7da f ch-chhar kafya f ch-chta, w mrtayn f ch-chhar wla koul osbou3 f s-sif (tonte, sqi, siyana). Hadchi kaytb3 l-masa7a w l-anwa3 l-maghrousa.', darija_ar: 'غالبا، زيارة وحدة فالشهر كافية فالشتا، ومرتين فالشهر ولا كل أسبوع فالصيف (تونط، سقي، صيانة). هادشي كيتبع المساحة والأنواع المغروسة.' },
      },
    ],
  },
};
